import { Link } from "react-router-dom";
import styled from "styled-components";

import {
  DATA_E2E_KEY,
  IStyledAttributes,
  REPORTS_HEADER_HEIGHT_COMPUTED,
} from "@ryde/shared";
import {
  blueGreyMui,
  deepPurpleMui,
  greyMui,
  MOBILE_BREAKPOINT,
  rydeColors,
} from "@ryde/theme";

export const ReportsPanelTopSettingsStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "reports-panel-top-settings",
  },
)`
  width: 100%;
  height: 30px;
  padding-inline-start: 20px;
  padding-inline-end: 15px;
  padding-top: 20px;
  padding-bottom: 20px;
  margin-bottom: 2px;
  display: flex;
  align-items: center;
`;

export const ReportsPanelTopWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "reports-panel-top-wrapper",
})`
  min-width: 100%;
  margin-bottom: 0;
  border-bottom: 1px solid ${greyMui._300};
  background-color: ${rydeColors.white};
`;

export const ReportsWrapperTableStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "reports-wrapper-table",
})`
  width: 100%;
  height: calc(100% - ${REPORTS_HEADER_HEIGHT_COMPUTED});
  background-color: ${rydeColors.smoke};
  padding-inline-start: 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 15px;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding-inline-start: 3px;
  }
`;

export const ReportsWrapperDiagramStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "reports-wrapper-diagram",
})`
  min-width: 100%;
  height: calc(100% - ${REPORTS_HEADER_HEIGHT_COMPUTED});
  background-color: ${rydeColors.smoke};
  padding-inline-start: 20px;
  display: grid;
  gap: 0 4px;
  grid-template-columns: 1fr;
  grid-template-rows: 50px 1fr;
`;

export const ReportTableHeadStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "reports-table-head",
})`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 14px;
  margin-inline-start: 10px;
  margin-inline-end: 13px;

  .report_info_wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    .report_title {
      font-size: 17px;
      color: ${blueGreyMui._800};
      display: flex;
      align-items: center;
      gap: 7px;
      .report_owner_category {
        font-size: 17px;
        color: ${greyMui._600};
      }
    }
    .report_description {
      line-height: 1.5;
      font-size: 12px;
      color: ${blueGreyMui._600};
    }
  }
  .report_buttons {
    margin-inline-start: auto;
    padding-inline-end: 15px;
    display: flex;
    align-items: center;
    gap: 8px;
    .report-download-csv {
      padding: 8px;
    }
    .open-settings-icon,
    .open-chart-icon {
      width: 24px;
      height: 24px;
      color: ${deepPurpleMui.A700};
      fill: ${deepPurpleMui.A700};
    }
    .delete_report_button {
      width: 24px;
      color: ${deepPurpleMui.A700};
    }

    .report_action_button {
      color: ${deepPurpleMui.A700};
      font-size: 27px;
    }

    .MuiIconButton-sizeMedium {
      padding-bottom: 3px;
    }
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    flex-direction: column;
  }
`;

export const ReportDashboardButtonStyled = styled(
  Link,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "report-dashboard-button",
})`
  color: ${deepPurpleMui.A700};
  display: flex;
  align-items: center;
  gap: 3px;
  margin-inline-start: 15px;
  padding-block: 4px;
  padding-inline: 5px;
  border: 1px solid ${greyMui._300};
  border-radius: 4px;
  &:hover {
    border: 1px solid ${greyMui._400};
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);
  }
  label {
    margin-inline-start: 3px;
    cursor: pointer;
    font-size: 14px;
  }
  .NavigateToDashboardButtonSVG {
    width: auto;
    height: 20px;
    display: block;
  }
`;

export const ViewSwitchWrapperReports = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "view-switch-reports-wrapper",
})`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-inline-start: 8px;
  margin-inline-end: 8px;
  svg {
    cursor: pointer;
  }
  .PieDiagramSVG {
    width: auto;
    height: 23px;
    display: block;
  }
  & > span {
    line-height: 10px;
  }
`;

export const ReportDownloadStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "report-download",
})`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  padding: 40px;
  background-color: ${rydeColors.white};
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  text-align: center;
  margin-top: 20px;
  margin-inline-end: 20px;

  .report_download_text {
    line-height: 1.5;
    font-size: 15px;
    color: ${deepPurpleMui.A200};
  }

  .report_download_btn {
    display: inline-flex;
    padding: 8px;
    background-color: ${deepPurpleMui.A400};
    border: 1px solid ${deepPurpleMui.A700};
    border-radius: 4px;
    color: white;
    font-size: 16px;
    text-decoration: none;
    cursor: pointer;
    transition: background-color 0.2s ease-in-out;
    &:hover {
      background-color: ${deepPurpleMui.A700};
    }
  }
`;
